/**
 * The typed client for ADMIN's routes (PRD-591): the review cockpit's reads and acts under /api/review.
 *
 * Admin is its own origin behind Identity-Aware Proxy, so this client is not the main API's. It carries
 * no Firebase bearer: the browser's IAP cookie is the identity, sent with `credentials: 'include'`, and
 * the page is served from admin's own origin (admin has no CORS middleware by design), so the base is
 * empty and every path is relative. In development the vite dev server proxies /api/review onto a running
 * admin (`make admin-screens ADMIN_PROXY=<origin>`), so the paths stay relative there too. The paths and bodies are
 * the generated `paths` of openapi.json, the same file that types the main client.
 */
import createClient, { type Client } from 'openapi-fetch';
import type { paths } from './types/api';

/** The one typed client for admin's JSON routes. */
export const adminClient: Client<paths> = createClient<paths>({ baseUrl: '', credentials: 'include' });
